import React from "react";
import WebProfitSpinner from "../../components/system/WebProfitSpinner";
import { Alert, Box, Button, Link, Stack, TextField } from "@mui/material";
import LockResetRoundedIcon from "@mui/icons-material/LockResetRounded";
import { Link as RouterLink } from "react-router-dom";
import { authApi } from "../../api/auth";
import {
  AuthPageShell,
  authLinkSx,
  authPrimaryButtonSx,
} from "../../components/dashboard/auth/AuthFormShell";

export default function ForgotPasswordPage() {
  const [email, setEmail] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const cleanEmail = String(email || "").trim().toLowerCase();

    if (!cleanEmail || !cleanEmail.includes("@")) {
      setError("Ingresá un email válido.");
      return;
    }

    try {
      setLoading(true);
      setError("");
      setMessage("");
      const data = await authApi.forgotPassword({ email: cleanEmail });
      setMessage(
        data?.message ||
          "Si el email está registrado, vas a recibir un enlace para crear una nueva contraseña.",
      );
    } catch (err) {
      setError(err.message || "No se pudo procesar la solicitud.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPageShell
      title="Recuperar contraseña"
      subtitle="Ingresá el email de tu cuenta."
      icon={<LockResetRoundedIcon />}
      helpLabel="Seguridad del enlace"
      help="Por seguridad, WebProfit no informa si un email está registrado. Si corresponde, vas a recibir un enlace de un solo uso para crear una contraseña nueva."
      footer={
        <Link component={RouterLink} to="/login" sx={authLinkSx}>
          Volver a ingresar
        </Link>
      }
    >
      {message ? <Alert severity="success">{message}</Alert> : null}
      {error ? <Alert severity="error">{error}</Alert> : null}

      <Box component="form" onSubmit={handleSubmit}>
        <Stack spacing={1.5}>
          <TextField
            label="Email"
            name="email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
            fullWidth
            autoFocus
            autoComplete="email"
            disabled={loading}
            inputProps={{ inputMode: "email", autoCapitalize: "none", spellCheck: "false" }}
          />
          <Button type="submit" disabled={loading} variant="contained" size="large" startIcon={loading ? <WebProfitSpinner size={17} /> : undefined} sx={authPrimaryButtonSx}>
            {loading ? "Enviando..." : "Enviar enlace"}
          </Button>
        </Stack>
      </Box>
    </AuthPageShell>
  );
}
